<template>
  <!-- 分销工作台 -->
  <div class="distribution-work-bench">
    <div class="work-top">
      <div class="work-bench-left-top">
        <div class="filter-area">
          <Select v-model="selectValue">
            <Option v-for="(item,index) in option" :key="index" :value="item.value">{{item.label}}</Option>
          </Select>
        </div>
        <sale-list :saleListConfig="saleListConfig"></sale-list>
      </div>
      <div class="work-bench-right-top">
        <info-list :info="saleInfo"></info-list>
      </div>
    </div>
    <div class="work-bottom">
      <div class="work-bench-left-bottom">
        <define-echart :id="'barContainer'" :option="barOption" class="barContainer"></define-echart>
        <div class="tablewrap">
          <stor-table :sortTableConfig="sortTableConfig"></stor-table>
        </div>
      </div>

      <div class="work-bench-right-bottom">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>
  </div>
</template>
<script>
import storTable from "commonCrumb/workBench/storTable.vue";
import infoList from "commonCrumb/workBench/infoList.vue";
import saleList from "commonCrumb/workBench/saleList.vue";
import defineEchart from "commonCrumb/workBench/defineEchart.vue";

export default {
  components: {
    storTable,
    infoList,
    saleList,
    defineEchart
  },
  data() {
    return {
      selectValue: 1,
      option: [
        {
          label: "测试数据1",
          value: 1
        },
        {
          label: "测试数据2",
          value: 2
        }
      ],
      saleListConfig: [
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 78452,
              label: "昨日销售总额"
            },
            {
              value: 65654,
              label: "今日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 78523,
              label: "昨日订单总量"
            },
            {
              value: 14523,
              label: "今日订单总量"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 56552,
              label: "昨日增会员总数"
            },
            {
              value: 45512,
              label: "今日增会员总数"
            }
          ]
        }
      ],
      saleInfo: {
        icon: "md-appstore",
        size: "30",
        color: "",
        custom: "",
        title: "促销活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      publicInfo: {
        icon: "ios-megaphone",
        size: "30",
        color: "",
        custom: "",
        title: "公告活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      sortTableConfig: {
        ranking: true, //排名列是否存在
        product: true, //带图片商品列是否存在
        columns: [
          {
            title: "销售金额",
            key: "xsje"
          }
        ],
        data: [
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 122
          },
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 741
          },
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 156
          }
        ],
        //dashedColor: "red", //默认红色, green:绿色  只有titleStyle为border时生效
        title: "畅销商品TOP榜",
        titleStyle: "default" //标题样式 default正常样式 border:带边框有颜色样式
      },
      //条形图配置等数据
      barOption: {
        title: {
          text: "近三日销售TOP榜"
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: [
            "乔丹百琪专卖店",
            "乔丹百尚专卖店",
            "乔丹百硕专卖店",
            "乔丹聪利专卖店",
            "乔丹官方旗舰店",
            "乔丹尊购专卖店",
            "乔丹童装企业店",
            "乔丹胜锐专卖店"
          ],
          axisLabel: {
            //设置x轴全都显示
            rotate: 30,
            interval: 0,
            fontSize: "12"
          }
        },
        legend: {
          right: "0px",
          bottom: "50%",
          orient: "vertical",
          data: ["销售金额", "订单总量"]
        },
        yAxis: {},
        series: [
          {
            name: "销售金额",
            type: "bar",
            data: [213, 323, 321, 123, 146, 234, 134, 311],
            itemStyle: {
              color: "#ff7c4d" //设置柱条的颜色
            }
          },
          {
            name: "订单总量",
            type: "bar",
            data: [144, 454, 214, 115, 213, 344, 421, 131],
            itemStyle: {
              color: "#50d27c"
            }
          }
        ]
      }
    };
  },
  methods: {
    setHeight() {
      //debugger
      let t_height = document.body.clientHeight - 230;
      document.getElementById("barContainer").style.height = t_height + "px";
    }
  },

  mounted() {
    this.setHeight();
    // this.draw();
  }
};
</script>
<style lang="less">
.distribution-work-bench {
  padding: 8px 12px;
  .work-top {
    display: flex;
    display: -webkit-flex;

    .work-bench-left-top {
      width: 80%;
      box-sizing: border-box;
      .filter-area {
        margin-bottom: 20px;
        text-align: right;
        .ark-select {
          width: 200px;
        }
      }
      .ark-col-span-8 {
        box-sizing: border-box;
      }
    }
    .work-bench-right-top {
      width: 20%;
    }
  }
  .work-bottom {
    margin-top: 20px;
    display: flex;
    display: -webkit-flex;
    .work-bench-left-bottom {
      width: 80%;
      overflow: hidden;
      .barContainer {
        float: left;
        width: 60%;
        height: 400px;
      }
      .tablewrap {
        float: left;
        width: 40%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        .sortTable {
          margin: 0 auto;
        }
      }
    }

    .work-bench-right-bottom {
      width: 20%;
    }
  }
}
</style>


